import {Injectable} from '@angular/core';
import {Tab} from '../../models/tab';
import {FloatLayout, FloatLayoutFactory} from '../float-layout';
import {Layout} from '../layout/layout';
import {LayoutFactory} from '../layout/layout.factory';
import {TabDefinition} from './tab-definition';

@Injectable()
export class TabFactory {

    constructor(
        private layoutFactory: LayoutFactory,
        private floatLayoutFactory: FloatLayoutFactory
    ) {}

    public createTabByDefinition(tabDefinition: TabDefinition, options?: {hasBeenJustAdded: boolean}): Tab {
        const tabId = tabDefinition.id || Tab.getNewTabId();

        const layout: Layout = tabDefinition.layout
            ? this.layoutFactory.createLayoutByDefinition({...tabDefinition.layout, tabId})
            : this.layoutFactory.createEmptyLayout(tabId);

        const floatLayout: FloatLayout = tabDefinition.floatLayout
            ? this.floatLayoutFactory.createFloatLayoutByDefinition({...tabDefinition.floatLayout, tabId})
            : this.floatLayoutFactory.createEmptyFloatLayout(tabId);

        return new Tab(
            tabId,
            tabDefinition.name,
            layout,
            floatLayout,
            options
        );
    }

    public getTabDefinition(tab: Tab): TabDefinition {
        return {
            id: tab.id,
            name: tab.name,
            layout: tab.layout && this.layoutFactory.getLayoutDefinition(tab.layout),
            floatLayout: tab.floatLayout && this.floatLayoutFactory.getFloatLayoutDefinition(tab.floatLayout)
        };
    }

}
